<script>
import Vue from 'vue'
export default {
    name: 'Sso',
    async beforeRouteEnter(to, from, next) {
        const user = Vue.prototype.$user
        if (to.query.sso_token) {
            try {
                if (user.isLoggedIn) await user.logout()
                await user.refreshToken(to.query.sso_token)
                if (to.query.impersonate) {
                    Vue.prototype.$impersonate.login(to.query.impersonate)
                }
                await user.getMe()
                next({ name: 'restaurant-list', params: { setLocation: true } })
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error(e)
                next({ name: 'login' })
            }
        } else if (to.query.impersonate_logout) {
            await Vue.prototype.$impersonate.logout()
        } else if (to.query.impersonate_exit) {
            await Vue.prototype.$impersonate.exit()
        } else {
            // eslint-disable-next-line no-console
            console.error('refresh token not found')
            next({ name: 'login' })
        }
    },

    render(h) {
        return h()
    },
}
</script>
